// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

p {
  margin: 0;
  padding: 0;
  letter-spacing: 0;
}
p.ellipsis {
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}
p.uppercase {
  text-transform: uppercase;
}
p.stroke {
  -webkit-text-stroke: 2px var(--ion-color-white);
}
p.c-primary {
  color: var(--ion-color-primary);
}
p.c-white {
  color: var(--ion-color-white);
}
p.c-title-text {
  color: var(--ion-color-title-text);
}
p.c-description-text {
  color: var(--ion-color-description-text);
}
p.c-dark {
  color: var(--ion-color-dark);
}
p.c-medium {
  color: var(--ion-color-medium);
}
p.c-light {
  color: var(--ion-color-light);
}
p.c-danger {
  color: var(--ion-color-danger);
}
p.c-version {
  color: var(--ion-color-version);
}
p.c-error {
  color: var(--ion-color-error);
}
p.c-pink {
  color: var(--ion-color-pink);
}
p.c-burgundy {
  color: var(--ion-color-burgundy);
}
p.c-dark-blue {
  color: var(--ion-color-dark-blue);
}
p.c-dark-grey {
  color: var(--ion-color-dark-grey);
}
p.c-emerald-dark {
  color: var(--ion-color-emerald-dark);
}
p.s-9 {
  font-size: 9px;
}
p.s-10 {
  font-size: 10px;
}
p.s-11 {
  font-size: 11px;
}
p.s-12 {
  font-size: 12px;
  line-height: 16px;
}
p.s-13 {
  font-size: 13px;
}
p.s-14 {
  font-size: 14px;
}
p.s-15 {
  font-size: 15px;
}
p.s-16 {
  font-size: 16px;
  line-height: 23px;
}
p.s-17 {
  font-size: 17px;
}
p.s-18 {
  font-size: 18px;
}
p.s-20 {
  font-size: 20px;
}
p.s-21 {
  font-size: 21px;
}
p.s-24 {
  font-size: 24px;
}
p.s-28 {
  font-size: 28px;
}
p.s-30 {
  font-size: 30px;
}
p.s-32 {
  font-size: 32px;
}
p.s-34 {
  font-size: 34px;
}
p.s-35 {
  font-size: 35px;
}
p.s-40 {
  font-size: 40px;
}
p.s-46 {
  font-size: 46px;
}
p.s-56 {
  font-size: 56px;
}
p.s-59 {
  font-size: 59px;
}
p.s-70 {
  font-size: 70px;
}
p.s-152 {
  font-size: 152px;
}
p.w-light {
  font-weight: 200;
}
p.w-regular {
  font-weight: normal;
}
p.w-medium {
  font-weight: 500;
}
p.w-semibold {
  font-weight: 600;
}
p.w-bold {
  font-weight: 700;
}
p.w-ultra-bold {
  font-weight: 800;
}`, "",{"version":3,"sources":["webpack://./src/app/components/text/text.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,iBAAA;AACF;AACE;EACE,qBAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,+CAAA;AADJ;AAIE;EACE,+BAAA;AAFJ;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,kCAAA;AAJJ;AAOE;EACE,wCAAA;AALJ;AAQE;EACE,4BAAA;AANJ;AASE;EACE,8BAAA;AAPJ;AAUE;EACE,6BAAA;AARJ;AAWE;EACE,8BAAA;AATJ;AAYE;EACE,+BAAA;AAVJ;AAaE;EACE,6BAAA;AAXJ;AAcE;EACE,4BAAA;AAZJ;AAeE;EACE,gCAAA;AAbJ;AAgBE;EACE,iCAAA;AAdJ;AAiBE;EACE,iCAAA;AAfJ;AAkBE;EACE,oCAAA;AAhBJ;AAmBE;EACE,cAAA;AAjBJ;AAoBE;EACE,eAAA;AAlBJ;AAqBE;EACE,eAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,iBAAA;AApBJ;AAuBE;EACE,eAAA;AArBJ;AAwBE;EACE,eAAA;AAtBJ;AAyBE;EACE,eAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,iBAAA;AAxBJ;AA2BE;EACE,eAAA;AAzBJ;AA4BE;EACE,eAAA;AA1BJ;AA6BE;EACE,eAAA;AA3BJ;AA8BE;EACE,eAAA;AA5BJ;AA+BE;EACE,eAAA;AA7BJ;AAgCE;EACE,eAAA;AA9BJ;AAiCE;EACE,eAAA;AA/BJ;AAkCE;EACE,eAAA;AAhCJ;AAmCE;EACE,eAAA;AAjCJ;AAoCE;EACE,eAAA;AAlCJ;AAqCE;EACE,eAAA;AAnCJ;AAsCE;EACE,eAAA;AApCJ;AAuCE;EACE,eAAA;AArCJ;AAwCE;EACE,eAAA;AAtCJ;AAyCE;EACE,eAAA;AAvCJ;AA0CE;EACE,gBAAA;AAxCJ;AA2CE;EACE,gBAAA;AAzCJ;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,gBAAA;AA3CJ;AA8CE;EACE,gBAAA;AA5CJ;AA+CE;EACE,gBAAA;AA7CJ;AAgDE;EACE,gBAAA;AA9CJ","sourcesContent":[":host {\n  display: block;\n}\n\np {\n  margin: 0;\n  padding: 0;\n  letter-spacing: 0;\n\n  &.ellipsis {\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n    overflow: hidden;\n  }\n\n  &.uppercase {\n    text-transform: uppercase;\n  }\n\n  &.stroke {\n    -webkit-text-stroke: 2px var(--ion-color-white);\n  }\n\n  &.c-primary {\n    color: var(--ion-color-primary);\n  }\n\n  &.c-white {\n    color: var(--ion-color-white);\n  }\n\n  &.c-title-text {\n    color: var(--ion-color-title-text);\n  }\n\n  &.c-description-text {\n    color: var(--ion-color-description-text);\n  }\n\n  &.c-dark {\n    color: var(--ion-color-dark);\n  }\n\n  &.c-medium {\n    color: var(--ion-color-medium);\n  }\n\n  &.c-light {\n    color: var(--ion-color-light);\n  }\n\n  &.c-danger {\n    color: var(--ion-color-danger);\n  }\n\n  &.c-version {\n    color: var(--ion-color-version);\n  }\n\n  &.c-error {\n    color: var(--ion-color-error);\n  }\n\n  &.c-pink {\n    color: var(--ion-color-pink);\n  }\n\n  &.c-burgundy {\n    color: var(--ion-color-burgundy);\n  }\n\n  &.c-dark-blue {\n    color: var(--ion-color-dark-blue);\n  }\n\n  &.c-dark-grey {\n    color: var(--ion-color-dark-grey);\n  }\n\n  &.c-emerald-dark {\n    color: var(--ion-color-emerald-dark);\n  }\n\n  &.s-9 {\n    font-size: 9px;\n  }\n\n  &.s-10 {\n    font-size: 10px;\n  }\n\n  &.s-11 {\n    font-size: 11px;\n  }\n\n  &.s-12 {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  &.s-13 {\n    font-size: 13px;\n  }\n\n  &.s-14 {\n    font-size: 14px;\n  }\n\n  &.s-15 {\n    font-size: 15px;\n  }\n\n  &.s-16 {\n    font-size: 16px;\n    line-height: 23px;\n  }\n\n  &.s-17 {\n    font-size: 17px;\n  }\n\n  &.s-18 {\n    font-size: 18px;\n  }\n\n  &.s-20 {\n    font-size: 20px;\n  }\n\n  &.s-21 {\n    font-size: 21px;\n  }\n\n  &.s-24 {\n    font-size: 24px;\n  }\n\n  &.s-28 {\n    font-size: 28px;\n  }\n\n  &.s-30 {\n    font-size: 30px;\n  }\n\n  &.s-32 {\n    font-size: 32px;\n  }\n\n  &.s-34 {\n    font-size: 34px;\n  }\n\n  &.s-35 {\n    font-size: 35px;\n  }\n\n  &.s-40 {\n    font-size: 40px;\n  }\n\n  &.s-46 {\n    font-size: 46px;\n  }\n\n  &.s-56 {\n    font-size: 56px;\n  }\n\n  &.s-59 {\n    font-size: 59px;\n  }\n\n  &.s-70 {\n    font-size: 70px;\n  }\n\n  &.s-152 {\n    font-size: 152px;\n  }\n\n  &.w-light {\n    font-weight: 200;\n  }\n\n  &.w-regular {\n    font-weight: normal;\n  }\n\n  &.w-medium {\n    font-weight: 500;\n  }\n\n  &.w-semibold {\n    font-weight: 600;\n  }\n\n  &.w-bold {\n    font-weight: 700;\n  }\n\n  &.w-ultra-bold {\n    font-weight: 800;\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
